import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetBulkOrderQueryOptions } from "@/requests/gen/react-query/bulk-order";
import { BulkOrderCrumbs } from "@/routes/_private/_practice-360/-crumbs";
import { BulkReorderScheduleForm } from "./-form";

export const Route = createFileRoute(
  "/_private/_practice-360/bulk-reorder/$bulkOrderId/schedule/",
)({
  loader: ({ context: { queryClient }, params: { bulkOrderId } }) =>
    queryClient.ensureQueryData(getGetBulkOrderQueryOptions(bulkOrderId)),
  component: BulkReorderSchedulePage,
});

function BulkReorderSchedulePage() {
  const { bulkOrderId } = Route.useParams();
  const bulk_order = useSuspenseQuery(
    suspenseOptions(getGetBulkOrderQueryOptions(bulkOrderId)),
  );

  return (
    <div>
      <title>Bulk Reorder Schedule - Legrande Health Portal</title>
      <BulkOrderCrumbs canEdit isReorder />

      <Card>
        <CardHeader>
          <CardTitle>Set Schedule</CardTitle>
          <CardDescription>Create a schedule for your reorder.</CardDescription>
        </CardHeader>
        <CardContent>
          {bulk_order.data ? (
            <BulkReorderScheduleForm bulk_order={bulk_order.data} />
          ) : (
            <div>Loading...</div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
